import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'settingsItem',
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  } //nothing
  ,
  props: {
    hideOn: {
      type: Boolean,
      "default": false
    },
    alwaysActive: {
      type: Boolean,
      "default": false
    },
    flipLogic: {
      type: Boolean,
      "default": false
    },
    proFeature: {
      type: Boolean,
      "default": false
    },
    basicFeature: {
      type: Boolean,
      "default": false
    },
    label: {
      type: String,
      required: true
    },
    isEnabled: {
      type: Boolean,
      "default": false
    },
    description: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    storeItem: {
      type: String,
      required: true
    },
    actionLabel: {
      type: String,
      required: false,
      "default": 'Click to activate'
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    returnIcon: function returnIcon() {
      return this.icon;
    },
    toggleState: function toggleState() {
      if (this.proFeature && !this.$store.state.proMembership) {
        this.$store.commit('updateUpgradeMessage', null);
        this.$store.commit('updateShowUpgradeMembershipPage', true);
        return;
      }
      // if(this.basicFeature && !this.$store.state.basicMembership){
      // 	this.$store.commit('updateUpgradeMessage', null);
      // 	this.$store.commit('updateShowUpgradeMembershipPage', true);
      // 	return;
      // }

      console.log('toggling state');
      if (this.label.toLowerCase() == 'text only') {
        this.toggleTextOnlyMode();
      } else if (this.label.toLowerCase() == 'context') {
        this.toggleContext();
      } else if (this.label.toLowerCase() == 'enable bluetooth controller') {
        this.$store.commit('updateBluetoothControllerConnected', !this.$store.state.bluetoothControllerConnected);
        this.$store.commit('mainMenuClose');
      } else if (this.label.toLowerCase() == 'continuous mode') {
        this.enableContinuousListeningMode();
      } else if (this.label.toLowerCase() == 'allow charts') {
        this.toggleChartResponses();
      } else if (this.label.toLowerCase() == 'allow code') {
        this.toggleCodeResponses();
      } else if (this.label.toLowerCase() == 'show logs') {
        this.toggleLogs();
      } else if (this.label.toLowerCase() == 'exceptional mode') {
        this.exceptionalMode();
      } else if (this.label.toLowerCase() == 'improved speech to text') {
        console.log('trying to sign out');
        this.speechToText();
      } else if (this.label.toLowerCase() == 'improved text to speech') {
        console.log('trying to sign out');
        this.textToSpeech();
      } else if (this.label.toLowerCase() == 'dial-in') {
        console.log('trying to sign out');
        this.dialin();
      } else if (this.label.toLowerCase() == 'use activation word') {
        console.log('trying to sign out');
        this.useActivationWord();
      }
    },
    useActivationWord: function useActivationWord() {
      this.$store.commit('updateUseActivationWord', !this.$store.state.useActivationWord);
    },
    dialin: function dialin() {
      this.$store.dispatch('checkFeatureEnabled', 'dialIn');
    },
    textToSpeech: function textToSpeech() {
      this.$store.dispatch('checkFeatureEnabled', 'textToSpeech');
    },
    speechToText: function speechToText() {
      this.$store.dispatch('checkFeatureEnabled', 'speechToText');
    },
    exceptionalMode: function exceptionalMode() {
      if (this.$store.state.exceptionalMode) {
        this.$store.commit('disableExceptionalMode');
      } else {
        this.$store.commit('enableExceptionalMode');
      }
      // to do add exception mode here
    },
    toggleTextOnlyMode: function toggleTextOnlyMode() {
      if (this.$store.state.textOnlyMode) {
        this.$store.commit('disableTextOnlyMode');
      } else {
        this.$store.commit('enableTextOnlyMode');
      }
    },
    enableContinuousListeningMode: function enableContinuousListeningMode() {
      if (this.$store.state.continuousListenMode) {
        this.$store.commit('disableContinuousListenMode');
      } else {
        this.$store.commit('enableContinuousListenMode');
      }
    },
    toggleChartResponses: function toggleChartResponses() {
      if (this.$store.state.enableChartResponses) {
        this.$store.commit('disableChartResponses');
      } else {
        this.$store.commit('enableChartResponses');
      }
    },
    closeSidebar: function closeSidebar() {
      this.$store.commit('mainMenuClose');
    },
    toggleCodeResponses: function toggleCodeResponses() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.$store.state.enableCodeResponses) {
                _this.$store.commit('disableCodeResponses');
              } else {
                _this.$store.commit('enableCodeResponses');
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    toggleContext: function toggleContext() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (_this2.$store.state.useContext) {
                console.log('toggle to disable');
                _this2.$store.commit('disableContext');
              } else {
                console.log('toggle to enable');
                _this2.$store.commit('enableContext');
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    toggleLogs: function toggleLogs() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this3.$store.state.showLogs) {
                console.log('toggle to disable');
                _this3.$store.commit('disableLogs');
              } else {
                console.log('toggle to enable');
                _this3.$store.commit('enableLogs');
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
});